import type { ModuleDefinition } from '../types';

export const workflowModule: ModuleDefinition = {
  key: 'workflow',
  milestone: 'M1',
  // REQ-WF-006 / plano M1 §8: item de navegação visível com `task.read` (supervisão); a inbox pessoal
  // (`/me/inbox`) é sempre acessível via `inbox.read`, base implícita, e não depende deste item de menu.
  network: { path: 'workflow', permission: 'task.read', labelKey: 'workflow' },
  tenant: { path: 'workflow', permission: 'task.read', labelKey: 'workflow' },
  load: () => import('./WorkflowModule'),
};
